import { Component, OnInit ,ViewChild,TemplateRef} from '@angular/core';
import { LogService } from '../../../_shared/log.service'
import { PriceService } from '@app/_services/masters/price.service';
import { first } from 'rxjs/operators';
import { price } from '@app/_models/price';
import { Subject } from 'rxjs';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-price-master',
  templateUrl: './price-master.component.html',
  styleUrls: ['./price-master.component.css']
})
export class PriceMasterComponent implements OnInit {

  price: price[];
  priceId: number;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(private modalService: NgbModal,private eventService: LogService, private priceService: PriceService) { }
  getresponse: any;
  delMessage: string;

  passData(dataValue, data) {
    //this.eventService.emit<any>(dataValue);
    this.eventService.emit({ dataValue, data });
  }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }

  @ViewChild('showModalDeleteBox', { read: TemplateRef }) showModalDeleteBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true
    };
    this.priceService.getPrice()
      .pipe(first())
      .subscribe(
        data => {
          console.log("price response---", data)
          this.price = data.respData;
          this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }
  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('10');
  }

  deletePrice(id)
  {
    this.priceId = id;
    this.modalService.open(this.showModalDeleteBoxTemplate);
  }
  
  deletePric() {
    this.priceService.deletePrice(this.priceId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("College response---", data)
          this.getresponse = data;

          if (this.getresponse.respMessage == "Success") {
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.open(this.showModalBoxTemplate);
            this.priceService.getPrice()
              .pipe(first())
              .subscribe(
                data => {
                  this.delMessage="Price Deleted Successfully."
                  console.log("Price response---", data)
                  this.price = data.respData;
                  //this.dtTrigger.next();
                },
                error => {
                  console.log(error)
                }
              )
          }
          else if (this.getresponse.respMessage == "Failure") {
            this.delMessage=this.getresponse.respData
            this.modalService.dismissAll(this.showModalDeleteBoxTemplate);
            this.modalService.dismissAll(this.showModalBoxTemplate);
          }
          //this.modalService.dismissAll(this.showModalDeleteBoxTemplate);

          // this.dtTrigger.next();
        },
        error => {
          console.log(error)
        }
      )
  }

}
